export const MEDICAL_VISITS = {
  key: 'MEDICAL_VISITS',
  group: 5,
  value: 11,
  title: 'health-record.medical-visits.title',
  menu_title: 'health-record.medical-visits.title',
  sub_title: 'health-record.medical-visits.medical-visits-title-example',
  list_title: 'HealthCare Visit',
  imageURL: require('@assets/images/Health-Record-Icons/Icon-Healthcare_Visits.svg'),
  icon: 'doctor',
  editor: 'MedicalVisitEditor',
  message_translate: 'health-record.medical-visits.message',
  model_name: 'medical_visit',
  resource: 'hr/medicalvisit/',
  plain_resource: 'medicalvisit',
  id: 'hr_id',
  headers: [
    {
      text: 'health-record.medical-visits.visit-date',
      value: 'record.date_formatted',
    },
    {
      text: 'health-record.medical-visits.professional',
      value: 'record.professional',
    },
    {
      text: 'health-record.medical-visits.reason',
      value: 'record.reason.value',
    },
    {
      text: 'health-record.medical-visits.symptoms',
      value: 'record.symptoms',
    },
    {
      text: 'health-record.medical-visits.diagnosis',
      value: 'record.diagnosis',
    },
    {
      text: 'health-record.actions',
      value: 'actions',
      sortable: false,
      width: '100px',
    },
  ],
  sortables: {
    record: {
      date_formatted: 'date',
      professional: 'professional',
      reason: {
        value: 'reason',
      },
      symptoms: 'symptoms',
      findings: 'findings',
      diagnosis: 'diagnosis',
      treatment: 'treatment',
    },
  },
  show_menu: true,
  background: 'linear-gradient(122.25deg, #43A047 3.07%, #4BB650 100%)',
  color: '#4AB34E',
  opaque: '#D7ECD8',
}
